import type { FC, ReactNode } from 'react';
import { Tag } from 'antd';

export type IpcStatusBadgeVariant = 'default' | 'primary' | 'success' | 'warning' | 'destructive' | 'muted';

type Props = {
  variant?: IpcStatusBadgeVariant;
  children: ReactNode;
  className?: string;
};

export const IpcStatusBadge: FC<Props> = ({ variant = 'default', children, className }) => (
  <Tag bordered={false} className={['ipc-badge', `ipc-badge--${variant}`, className].filter(Boolean).join(' ')}>
    {children}
  </Tag>
);
